/**
 * Cross-app navigation helpers for the marketing site.
 *
 * The marketing site is a standalone, unauthenticated SPA. Every "sign in",
 * "register", or "vault owner" call-to-action links OUT to another app:
 *
 *   - the adviser app  (apps/app)   → VITE_APP_URL       (e.g. app.securelegacy.com.au)
 *   - the vault app     (apps/vault) → VITE_VAULT_APP_URL (e.g. vault.securelegacy.com.au)
 *
 * Both fall back to their local dev ports when the env vars are unset.
 */
const APP_ORIGIN = (
  import.meta.env.VITE_APP_URL || "http://localhost:3000"
).replace(/\/$/, "");

const VAULT_ORIGIN = (
  import.meta.env.VITE_VAULT_APP_URL || "http://localhost:3001"
).replace(/\/$/, "");

/** Build an absolute URL into the adviser app (apps/app). */
export function appUrl(path: string = "/"): string {
  return `${APP_ORIGIN}${path === "/" ? "/" : path}`;
}

/** Build an absolute URL into the vault app (apps/vault). */
export function vaultAppUrl(path: string = "/"): string {
  return `${VAULT_ORIGIN}${path === "/" ? "/" : path}`;
}
